"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Users/Admin/View/tabs/Enrollments.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    EnrolItem_template = require("../../../../../components/EnrolItem.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    EnrolItem_tag = marko_loadTag(EnrolItem_template),
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_attrs0 = {
        style: "height:30vh",
        "class": "d-flex align-items-center justify-content-center"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (Array.isArray(input.enrollments) && input.enrollments.length) {
    marko_forOf(input.enrollments, function(each, index) {
      EnrolItem_tag(marko_assign({
          readonly: true
        }, each), out, __component, index);
    });
  } else {
    out.be("div", marko_attrs0, "0", component);

    Locale_tag({
        text: "No Enrollment",
        class: "text-muted"
      }, out, __component, "1");

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
